<template>
  <div
    v-if="getT"
    class="options-container"
    :class="{ 'collapsed': collapsed }">
    <ul class="option-list">
      <li><OptionSize/></li>
      <li v-if="currPool.options.install"><OptionInstallType @installTypeClick="logInstall($event, currPool)"/></li>
      <li v-if="currPool.options.location"><OptionLocation @clickedLocation="logLocation($event, currPool)"/></li>
      <li v-if="currPool.options.liner"><OptionDropdownImage show="currPool.options.liner" optionKey="liner" @clickedToggleOption="logLiner($event, currPool)" /></li>
      <li v-if="currPool.options.system"><OptionDropdownImage optionKey="system"  @clickedToggleOption="logSystem($event, currPool)"/></li>
      <li v-if="currPool.options.shell"><OptionDropdownImage optionKey="shell" @clickedToggleOption="logShell($event, currPool)"/></li>
    </ul>
  </div>
</template>
<script>
import OptionSize from './OptionSize'
import OptionDropdownImage from './OptionDropdownImage'
import OptionInstallType from './OptionInstallType'
import OptionLocation from './OptionLocation'
import { mapGetters } from 'vuex';

export default {
  name: 'OptionList',
  props: [ 'collapsed' ],
  components: {
    OptionSize,
    OptionDropdownImage,
    OptionInstallType,
    OptionLocation
  },
  computed: {
    ...mapGetters(['getT', 'currPool']),
  },
  methods: {
    logInstall($event, model){
      this.$gtag.event($event + 'Install Clicked', {
        'event_category': 'Install Option Selection',
        'event_label': $event + 'Install Clicked',
        'selected_pool': model.title
      });
    },
    logLocation($event, model){
      this.$gtag.event($event + ' Location Clicked', {
        'event_category': 'Location Option Selection',
        'event_label': $event + ' Location Clicked',
        'selected_pool': model.title
      });
    },
    logLiner($event, model){
      this.$gtag.event($event + ' Liner Clicked', {
        'event_category': 'Liner Option Selection',
        'event_label': $event + ' Liner Clicked',
        'selected_pool': model.title
      });
    },
    logSystem($event, model){
      this.$gtag.event($event + ' System Clicked', {
        'event_category': 'System Option Selection',
        'event_label': $event + ' System Clicked',
        'selected_pool': model.title
      });
    },
    logShell($event, model){
      this.$gtag.event($event + ' Shell Clicked', {
        'event_category': 'Shell Option Selection',
        'event_label': $event + ' Shell Clicked',
        'selected_pool': model.title
      });
    },
    
  },
  
}
</script>
<style scoped lang="scss">
.options-container {
  padding-top: 3rem;
  overflow-y: auto;
  overflow-x: hidden; // iOS - prevent horizontal drag
  ul.option-list {
    margin: 0;
    padding: 0;
    li {
      line-height: 0;
      & > div {
        line-height: normal;
      }
    }
  }
}
</style>
